<template>
  <div
    :class="`quizz-container ${getColor(key)}`"
    v-for="(response, key) in result.responses"
    :key="key"
  >
    <div v-if="game === 1">
      <p>Réponse</p>
      <img
        v-if="
          response.goodResponse.image[0] !== response.response.plant.image[0]
        "
        class="banner-quizz error-image"
        :src="'../img/data/' + response.response.plant.image[0]"
      />
      <img
        class="banner-quizz"
        :src="'../img/data/' + response.response.defaultImagePlant"
      />
      <p class="align-left">
        <b>Nom Latin:</b> <i>{{ response.goodResponse.nomlatin }}</i>
      </p>
      <p class="align-left">
        <b>Famille: </b>
        <i>{{ this.getNameOfFamily(response.goodResponse.famille) }}</i>
      </p>

      <p
        class="align-left"
        v-if="response.goodResponse.toxic !== response.response.toxicity"
      >
        Toxique: <s>{{ response.response.toxicity ? "Oui" : "Non" }} </s>
        <br />
        <b> {{ response.goodResponse.toxic ? "Oui" : "Non" }}</b>
      </p>
      <p class="align-left" v-else>
        Toxique: {{ response.goodResponse.toxic ? "Oui" : "Non" }}
      </p>

      <p
        class="align-left"
        v-if="response.goodResponse.nom !== response.response.plant.nom"
      >
        Nom: <s>{{ response.response.plant.nom }} </s>
        <br />
        <b> {{ response.goodResponse.nom }}</b>
      </p>
      <p class="align-left" v-else>Nom: {{ response.goodResponse.nom }}</p>
    </div>
    <div v-if="game === 2">
      <p>Réponse</p>
      <img
        class="banner-quizz"
        :src="'../img/data/' + response.response.defaultImagePlant"
      />
      <p class="align-left">
        <i>Nom Latin: {{ response.goodResponse.nomlatin }}</i>
      </p>
      <p
        class="align-left"
        v-if="response.goodResponse.toxic !== response.response.toxicity"
      >
        Toxique: <s>{{ response.response.toxicity ? "Oui" : "Non" }} </s>
        {{ response.goodResponse.toxic ? "Oui" : "Non" }}
      </p>
      <p class="align-left" v-else>
        Toxique: {{ response.goodResponse.toxic ? "Oui" : "Non" }}
      </p>

      <p
        class="align-left"
        v-if="response.goodResponse.nom !== response.response.plant.nom"
      >
        Nom: <s>{{ response.response.plant.nom }} </s>
        {{ response.goodResponse.nom }}
      </p>
      <p v-else>Nom: {{ response.goodResponse.nom }}</p>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "correction",
  props: {
    result: Object,
  },
  data() {
    return {
      errorType: [],
    };
  },
  computed: {
    ...mapGetters({
      game: "game",
    }),
  },
  methods: {
    getColor(key) {
      const goodResponse = this.result.responses[key].goodResponse;
      const response = this.result.responses[key].response;

      if (
        goodResponse.nom === response.plant.nom &&
        goodResponse.toxic === response.toxicity
      ) {
        return "success";
      } else if (goodResponse.nom !== response.plant.nom) {
        return "error";
      } else {
        return "error";
      } // genre c'est ici qu'il faut afficher le bon nom et le nom qu'il a choisis
    },
    getNameOfFamily(family) {
      switch (family) {
        case "1":
          return "Apiacées";
        case "2":
          return "Astéracées";
        case "3":
          return "Fabacées";
        case "4":
          return "Lamiacées";
        case "5":
          return "Rosacées";
        case "6":
          return "Solanacées";
        case "7":
          return "Sapindacées";
        case "8":
          return "Renonculacées";
        case "9":
          return "Caryophyllacées";
        case "10":
          return "Verbénacées";
          break;
        case "11":
          return "Malvacées";
        case "12":
          return "Brassicacées";
        case "13":
          return "Aristolochiacées";
        case "14":
          return "Asparagacées";
        case "15":
          return "Ptéridophytes";
        case "16":
          return "Bétulacées";
        case "17":
          return "Borraginacées";
        case "18":
          return "Poacées";
        case "19":
          return "Cucurbitacées";
        case "20":
          return "Éricacées";
          break;
        case "21":
          return "Cannabinacées";
        case "22":
          return "Fagacées";
        case "23":
          return "Apocynacées";
        case "24":
          return "Caprifoliacées";
        case "25":
          return "Papavéracées";
        case "26":
          return "Rubiacées";
        case "27":
          return "Colchiacées";
        case "28":
          return "Coriariacées";
        case "29":
          return "Plantaginacées";
        case "30":
          return "Célastracées";
          break;
        case "31":
          return "Euphorbiacées";
        case "32":
          return "Polygonacées";
        case "33":
          return "Moracées";
        case "34":
          return "Rhamnacées";
        case "35":
          return "Oléacées";
        case "36":
          return "Géraniacées";
        case "37":
          return "Gymnospermes";
        case "38":
          return "Araliacées";
        case "39":
          return "Hypéricacées";
        case "40":
          return "Lauracées";
          break;
        case "41":
          return "Urticacées";
        case "42":
          return "Phytolaccacées";
        case "43":
          return "Platanacées";
        case "44":
          return "Salicacées";
        case "45":
          return "Rutacées";
        case "46":
          return "Adoxacées";
        case "47":
          return "Smilacées";
        case "48":
          return "Dioscoracées";
        case "49":
          return "Scrofulariacées";
        case "50":
          return "Vitacées";
          break;
      }
    },
  },
};
</script>
